import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getAccommodationOverview } from '../api/admin';
import { useCountry } from '../context/CountryContext';

const AccommodationOverview = () => {
  const { country } = useCountry();
  const [data, setData] = useState(null);

  useEffect(() => {
    const params = country !== 'ALL' ? { country } : {};
    getAccommodationOverview(params).then((res) => setData(res.data));
  }, [country]);

  if (!data) return <div style={s.page}>Loading…</div>;

  return (
    <div style={s.page}>
      <h1 style={s.h1}>Accommodation/Providers — Overview</h1>
      <div style={s.cards}>
        <div style={s.card}><div style={s.cardLabel}>Total listings</div><div style={s.cardValue}>{data.total}</div></div>
        <div style={s.card}><div style={s.cardLabel}>Pending review</div><div style={s.cardValue}>{data.by_status?.pending || 0}</div></div>
        <div style={s.card}><div style={s.cardLabel}>Approved</div><div style={s.cardValue}>{data.by_status?.approved || 0}</div></div>
        <div style={s.card}><div style={s.cardLabel}>Suspended</div><div style={s.cardValue}>{data.by_status?.suspended || 0}</div></div>
      </div>

      <h3 style={s.h3}>By category</h3>
      <div style={s.row}>
        {Object.entries(data.by_category || {}).map(([cat, count]) => (
          <Link key={cat} to={`/accommodation/listings/${cat === 'wedding_venue' ? 'wedding_hall' : cat}`} style={s.chip}>{cat.replace('_', ' ')}: {count}</Link>
        ))}
      </div>

      <h3 style={s.h3}>By country</h3>
      <div style={s.row}>
        {Object.entries(data.by_country || {}).map(([c, count]) => (
          <div key={c} style={s.chipStatic}>{c}: {count}</div>
        ))}
      </div>
    </div>
  );
};

const s = {
  page: { padding: 24, maxWidth: 900 },
  h1: { fontSize: 22, fontWeight: 800, marginBottom: 20 },
  h3: { fontSize: 14, fontWeight: 700, color: '#6b7280', marginTop: 24, marginBottom: 10, textTransform: 'uppercase' },
  cards: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))', gap: 12 },
  card: { background: 'white', border: '1px solid #e5e7eb', borderRadius: 12, padding: 16 },
  cardLabel: { fontSize: 12, color: '#6b7280', marginBottom: 6 },
  cardValue: { fontSize: 26, fontWeight: 800, color: '#111827' },
  row: { display: 'flex', gap: 8, flexWrap: 'wrap' },
  chip: { padding: '6px 12px', borderRadius: 999, background: '#ecfdf5', color: '#065f46', fontSize: 12.5, fontWeight: 600, textDecoration: 'none' },
  chipStatic: { padding: '6px 12px', borderRadius: 999, background: '#f3f4f6', color: '#374151', fontSize: 12.5, fontWeight: 600 },
};

export default AccommodationOverview;
